// extracted by mini-css-extract-plugin
export default {"container":"ScrollIndicator_container__s29aq","bar":"ScrollIndicator_bar__cpUym","rounded":"ScrollIndicator_rounded__f6Ey5"};